// extracted by mini-css-extract-plugin
export var text = "_3c-0";